<template>
  <div v-if="dialog" class="modal-overlay">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ $t('homepage.demoModal.title') }}</h3>
        <button class="close-btn" @click="closeModal">&times;</button>
      </div>
            <div class="modal-body">
        <form @submit.prevent="submit">
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('homepage.demoModal.firstName') }}</label>
              <input v-model="form.firstName" type="text" required />
            </div>
            <div class="form-group">
              <label>{{ $t('homepage.demoModal.lastName') }}</label>
              <input v-model="form.lastName" type="text" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('homepage.demoModal.email') }}</label>
              <input v-model="form.email" type="email" required />
            </div>
            <div class="form-group">
              <label>{{ $t('homepage.demoModal.phoneNumber') }}</label>
              <input v-model="form.phoneNumber" type="tel" required />
            </div>
          </div>
          <div class="form-group">
            <label>{{ $t('homepage.demoModal.companyName') }}</label>
            <input v-model="form.companyName" type="tel" required />
          </div>
          <div class="form-group">
            <label>{{ $t('homepage.demoModal.comment') }}</label>
            <textarea v-model="form.comment" rows="3" :placeholder="$t('homepage.demoModal.commentPlaceholder')"></textarea>
          </div>
          <div class="recaptcha-container">
            <vue-recaptcha
              class="vue-recaptcha"
              @verify="receivedCaptcha"
              sitekey="6LeyYKgrAAAAAPjYH70GZAeKE8Tz7cnnR-rlj9jE"
            />
          </div>
          <div class="form-actions">
            <v-btn type="button" class="secondary" @click="closeModal" medium>{{ $t('homepage.demoModal.cancel') }}</v-btn>
            <v-btn type="submit" style="background-color: #1876D1; color: white;" medium>{{ $t('homepage.demoModal.submit') }}</v-btn>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { requestDemo } from '@/services/users'
export default {
  name: 'DemoModal',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      captchaToken: '',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        companyName: '',
        comment: ''
      }
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    closeModal() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.form.firstName = '';
      this.form.lastName = '';
      this.form.email = '';
      this.form.phoneNumber = '';
      this.form.companyName = '';
      this.form.comment = '';
      this.captchaToken = '';
    },
    submit() {
      this.isSubmitting = true;
      requestDemo(this.form, this.captchaToken)
        .then(() => {
          this.closeModal();
          this.$emit('demo-requested');
        })
    },
    receivedCaptcha(response) {
      this.captchaToken = response;
    }
  },
  components: {
    VueRecaptcha
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  animation: fadeIn 0.2s ease-out;
}

.modal-content {
  background: #fefefe;
  border-radius: 12px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease-out;
}

.modal-header {
  background-color: #1876D1;
  color: white;
  padding: .75rem;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.155rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.close-btn {
  color: white;
  font-size: 1.54rem;
  cursor: pointer;
  padding: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-body {
  padding: 2rem;
}

.form-row {
  display: flex;
  gap: 1.5rem;
}

.form-group {
  flex: 1;
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 500;
  color: #1f2937;
  font-size: 0.67375rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.77rem;
  font-family: inherit;
  background: #f9fafb;
  color: #1f2937;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1876D1;
  background: #d1d5db;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.btn {
  padding: 0.875rem 2rem;
  border: none;
  border-radius: 12px;
  font-size: 0.77rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  min-width: 120px;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

.btn-primary {
  background: linear-gradient(135deg, #1876D1, #1876D1);
  color: white;
  box-shadow: 0 4px 15px rgba(30, 64, 175, 0.3);
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #1876D1, #1876D1);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(30, 64, 175, 0.4);
}

.btn-primary:disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
  border: 2px solid #e5e7eb;
}

.btn-secondary:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
  transform: translateY(-1px);
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .modal-content {
    width: 95%;
    margin: 1rem;
  }
  
  .modal-body {
    padding: 1.5rem;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
  }
}

.recaptcha-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
}

.vue-recaptcha {
  transform: scale(0.8);
  transform-origin: right center;
}
</style>
